export default {"src":"/_next/static/media/ice-cream.41eefcb4.svg","height":486,"width":486,"blurWidth":0,"blurHeight":0};